import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class LoaderService {


    public loading = false;

    public startLoading(): void {
        this.loading = true;
    }

    public stopLoading(): void {
        this.loading = false;
    }
}
